import { useState, useReducer } from 'react'

export function useExcelRules(data) {
  const DATASET = data.dataset
  const [filteredData, setFilteredData] = useState(
    data.dataset.sort((a, b) => {
      return a.user_info.last_name.toLowerCase() <
        b.user_info.last_name.toLowerCase()
        ? -1
        : 1
    })
  )
  const textFilters = [
    { name: 'email', description: 'Email contains' },
    { name: 'first_name', description: 'First name contains' },
    { name: 'last_name', description: 'Last name contains' },
  ]
  const initFilterValues = (function () {
    const filters = []
    let id = 0
    data.severities.forEach(severity => {
      filters.push({
        type: 'checkbox',
        category: 'severities',
        name: severity,
        id: id.toString(),
        active: false,
      })
      id++
    })
    data.rules.forEach(rule => {
      filters.push({
        type: 'checkbox',
        category: 'rules',
        name: rule,
        id: id.toString(),
        active: false,
      })
      id++
    })
    textFilters.map(item => {
      filters.push({
        type: 'text',
        category: 'text',
        name: item.name,
        description: item.description,
        id: id.toString(),
        active: false,
        value: null,
      })
      id++
    })

    return filters
  })()

  const [filterState, updateFilterState] = useReducer(reducer, initFilterValues)

  function reducer(state, action) {
    switch (action.type) {
      case 'reset':
        return initFilterValues
      case 'checkbox':
        // Invert the active state of the item whose ID is sent in the payload, while maintaing rest of the state.
        return state.map(item => {
          if (item.id === action.payload.id) {
            return { ...item, active: !item.active }
          } else {
            return item
          }
        })

      case 'text':
        return state.map(item => {
          if (item.id === action.payload.id) {
            return {
              ...item,
              active: action.payload.value === '' ? false : true,
              value: action.payload.value.toLowerCase(),
            }
          } else {
            return item
          }
        })
    }
  }

  function applyFilterState() {
    if (getActiveFilters() === undefined) return
    const activeFilters = getActiveFilters()
    const tempData = DATASET.filter(student => {
      for (const checkboxFilters of activeFilters['checkbox']) {
        if (!student.possible_filters.includes(checkboxFilters.name)) {
          return false
        }
      }
      for (const textFilters of activeFilters['text']) {
        if (textFilters.value === null) continue
        if (
          !student.user_info[textFilters.name]
            .toLowerCase()
            .includes(textFilters.value)
        ) {
          return false
        }
      }
      return true
    })
    setFilteredData(tempData)
  }

  function clearFilters() {
    updateFilterState({ type: 'reset' })
    setFilteredData(DATASET)
  }

  function getActiveFilters() {
    const obj = {}
    let tempArray = filterState.filter(item => item.active)
    obj['text'] = tempArray.filter(item => item.type === 'text')
    obj['checkbox'] = tempArray.filter(item => item.type === 'checkbox')
    if (obj['text'].length === 0 && obj['checkbox'].length === 0)
      return undefined
    return obj
  }

  return {
    applyFilterState,
    filters: initFilterValues,
    data: filteredData,
    updateFilterState,
    clearFilters,
  }
}
